import React, { useState,useEffect } from "react";
import './TaPayxPage.css';
import AOS from "aos";
import "aos/dist/aos.css";
 import { FaLaptop,FaUserTie, FaClipboardCheck,FaChartBar,FaUsers,FaCloud, FaUniversity, FaCheckCircle ,FaCreditCard, FaLock, FaUserFriends, FaGift, FaBolt, FaShieldAlt} from 'react-icons/fa';
 
export default function TaPayxPage() {
   const [activeTab, setActiveTab] = useState("employee");
const employeeBenefits = [
  {
    icon: <FaCreditCard size={26} />,
    bg: "linear-gradient(135deg, #6366f1, #8b5cf6)", // Purple-blue
    title: "One Card",
    desc: "A single card for all employee benefits and seamless spending."
  },
  {
    icon: <FaLock size={26} />,
    bg: "linear-gradient(135deg, #10b981, #34d399)", // Green
    title: "Work Assistance",
    desc: "24/7 access to make requests and manage benefits online easily."
  },
  {
    icon: <FaBolt size={26} />,
    bg: "linear-gradient(135deg, #f97316, #f59e0b)", // Orange-yellow
    title: "Instant Approval",
    desc: "Get fast approvals with a smart system built for growing teams."
  },
  {
    icon: <FaGift size={26} />,
    bg: "linear-gradient(135deg, #ec4899, #f472b6)", // Pink
    title: "No Capex",
    desc: "Zero upfront investment with free employee card issuance."
  },
  {
    icon: <FaShieldAlt size={26} />,
    bg: "linear-gradient(135deg, #10b981, #34d399)", // Green
    title: "100% Secure",
    desc: "Bank-grade security protecting all transactions and data."
  },
  {
    icon: <FaUsers size={26} />,
    bg: "linear-gradient(135deg, #6366f1, #60a5fa)", // Indigo-blue
    title: "Happy Employees",
    desc: "Delight your team with a smooth and flexible payment experience."
  }
];

const hrBenefits = [
  {
    icon: <FaUserTie size={26} />,
    bg: "linear-gradient(135deg, #8b5cf6, #6366f1)", // Purple
    title: "Central Control",
    desc: "Manage all employee cards and expenses from one easy dashboard."
  },
  {
    icon: <FaClipboardCheck size={26} />,
    bg: "linear-gradient(135deg, #f59e0b, #f97316)", // Orange-yellow
    title: "Compliance Ready",
    desc: "Keep audits stress-free with detailed logs and secure workflows."
  },
  {
    icon: <FaChartBar size={26} />,
    bg: "linear-gradient(135deg, #60a5fa, #3b82f6)", // Blue
    title: "Reports & Insights",
    desc: "Analyze spending trends and optimize budgets with smart insights."
  },
  {
    icon: <FaGift size={26} />,
    bg: "linear-gradient(135deg, #ec4899, #f472b6)", // Pink
    title: "Zero Capex",
    desc: "Setup at zero cost with no hardware or licensing investment."
  },
  {
    icon: <FaShieldAlt size={26} />,
    bg: "linear-gradient(135deg, #10b981, #34d399)", // Green
    title: "Advanced Security",
    desc: "Enterprise-grade protection with PIN sync and encryption."
  },
  {
    icon: <FaUsers size={26} />,
    bg: "linear-gradient(135deg, #6366f1, #60a5fa)", // Indigo-blue
    title: "Better Engagement",
    desc: "Boost employee morale with hassle-free reimbursements and perks."
  }
];

 useEffect(() => {
  AOS.init({ duration: 1000 });
}, []);
  const benefits = activeTab === "employee" ? employeeBenefits : hrBenefits;
  return (
    
    <div className="ta">
      <div >
    <section className="section-card ">
  {/* Left Content */}
  <div className="section-content" data-aos="fade-right">
    <h1>TA PAYX</h1>
    <p className="subtitle">Reinventing Corporate Travel & Expense Management</p>
    <p className="description">
      Streamline your business expenses with our comprehensive platform.
      Automate travel bookings, manage reimbursements, and gain complete
      visibility into your corporate spending.
    </p>
    <button className="btn-primary" onClick={() => (window.location.href = "/")}>
      Get Started
    </button>
  </div>

  {/* Right-side Image */}
  <div className="section-image" data-aos="zoom-in-up">
    <img
      src="/assets/images/tapayximg.png"
      alt="Corporate Travel Illustration" 
    />
  </div>
</section>

</div>

<section className="wallet-features">
  <div className="container">
    <h2>
    All Employee Benefits in a Single Wallet Solution
    </h2>
    <p className="wallet-subtitle">
      We have a rapidly growing list of Use Cases from our clients
    </p>

    <div className="wallet-grid">
      {/* First Row */}
      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #f97316, #facc15)" }}>🍽️</div>
        <h3>Meal Vouchers</h3>
        <p>Digital meal voucher solutions for employees</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #6366f1, #8b5cf6)" }}>📱</div>
        <h3>Telecom Reimbursements</h3>
        <p>Automated telecom expense management</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #10b981, #34d399)" }}>⛽</div>
        <h3>Fuel Cards</h3>
        <p>Comprehensive fuel expense tracking</p>
      </div>

      {/* Second Row */}
      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #3b82f6, #60a5fa)" }}>🚗</div>
        <h3>Fleet Management</h3>
        <p>Complete vehicle fleet oversight</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #ec4899, #f472b6)" }}>🎁</div>
        <h3>Employee Rewards</h3>
        <p>Recognition and reward programs</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #06b6d4, #22d3ee)" }}>💳</div>
        <h3>Corporate Cards</h3>
        <p>Secure corporate card solutions</p>
      </div>
    </div>

    {/* Third Row */}
    <div className="wallet-mini-row">
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #8b5cf6, #ec4899)" }}>📊</div>
        <p className="wallet-mini-text">Real-time Analytics</p>
      </div>
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #10b981, #34d399)" }}>🔒</div>
        <p className="wallet-mini-text">Bank-level Security</p>
      </div>
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #3b82f6, #60a5fa)" }}>📱</div>
        <p className="wallet-mini-text">Mobile First</p>
      </div>
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #f59e0b, #fbbf24)" }}>⚡</div>
        <p className="wallet-mini-text">Instant Processing</p>
      </div>
    </div>
  </div>
</section>

   <section className="secure-section">
      <h2 className="secure-title">Secure By Design</h2>
      <p className="secure-subtitle">Enterprise-grade security with complete compliance and control</p>

      <div className="secure-grid">
        <div className="secure-card">
          <div className="secure-icon bg-blue"><FaLaptop size={28} /></div>
          <h3>Completely Digital</h3>
          <p>No need to carry cards</p>
        </div>

        <div className="secure-card">
          <div className="secure-icon bg-green"><FaLock size={28} /></div>
          <h3>Convenience</h3>
          <p>Just One Card at any ATM location</p>
        </div>

        <div className="secure-card">
          <div className="secure-icon bg-purple"><FaCloud size={28} /></div>
          <h3>Hosted on a Resilient & Secure Cloud platform</h3>
          <p>Enterprise cloud infrastructure</p>
        </div>

        <div className="secure-card">
          <div className="secure-icon bg-orange"><FaUniversity size={28} /></div>
          <h3>Bank-Grade Security</h3>
          <p>PCI DSS compliant systems</p>
        </div>
      </div>

      <div className="secure-subgrid">
        <div className="secure-block">
          <h3>Security</h3>
          <p>Enable the card from app when you want to use it and disable it when you don’t. Secure PIN synchronization.</p>
          <div className="icon-row">
            <div className="icon-circle bg-green"><FaLock /></div>
            <div className="icon-circle bg-purple"><FaShieldAlt /></div>
          </div>
        </div>

        <div className="secure-block">
          <h3>Flexibility</h3>
          <p>Use at any bank location in India accepting Rupay Cards.</p>
          <div className="status-box">
            <span>Available 24/7</span>
            <FaCheckCircle className="check-icon" />
          </div>
        </div>
      </div>
    </section>

<section className="benefits-section">
      <h3 ><b>Benefits at a Glance</b></h3>

      <div className="toggle-buttons">
        <button
          className={`tab-btn ${activeTab === "employee" ? "active" : ""}`}
          onClick={() => setActiveTab("employee")}
        >
          For Employees
        </button>
        <button
          className={`tab-btn ${activeTab === "hr" ? "active" : ""}`}
          onClick={() => setActiveTab("hr")}
        >
          For HR
        </button>
      </div>

      <div className="benefits-grid">
        {benefits.map((item, index) => (
          <div className="benefits-card" key={index}>
            <div className="icon" style={{ background: item.bg }}>
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="cta-banner">
        <h4><b>Ready to Transform Your Employee Benefits?</b></h4>
        <p>
          Join thousands of companies who have already revolutionized their
          employee experience with our comprehensive platform.
        </p>
        <button className="cta-button">Get Started Today</button>
      </div>
    </section>
  </div>
  );
}
 
 